import React, { useState } from "react";
import { Autocomplete, Box, Popover, TextField, Typography } from "@mui/material";
import { IconSearch } from "@tabler/icons-react";
import { useCustomer360 } from "components/customer360/Customer360Context";
import {
  asyncAutocompleteListboxProps,
  buildCustomerSearchUrl,
  handleAsyncAutocompleteInputChange,
  noLocalFilter,
  useAsyncEntitySearch,
} from "utils/entity-autocomplete";
import { formatCpf } from "utils/attendance";

const CustomerSearchButton = () => {
  const { openCustomer } = useCustomer360();
  const [anchorEl, setAnchorEl] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const open = Boolean(anchorEl);

  const {
    options,
    loading,
    search,
    listboxKey,
  } = useAsyncEntitySearch({
    buildUrl: buildCustomerSearchUrl,
  });

  const handleClose = () => {
    setAnchorEl(null);
    setInputValue("");
  };

  return (
    <>
      <Box
        component="button"
        type="button"
        aria-label="Buscar cliente"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          border: 0,
          background: "transparent",
          cursor: "pointer",
          color: "secondary.dark",
          borderRadius: "12px",
          px: 1,
          py: 0.5,
          font: "inherit",
          "&:hover": {
            backgroundColor: "secondary.light",
          },
        }}
      >
        <IconSearch stroke={1.5} size="1.1rem" />
        <Typography variant="body2" sx={{ fontWeight: 600, display: { xs: "none", sm: "block" } }}>
          Buscar cliente
        </Typography>
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Box sx={{ p: 2, width: { xs: 280, sm: 360 } }}>
          <Autocomplete
            options={options}
            loading={loading}
            inputValue={inputValue}
            filterOptions={noLocalFilter}
            ListboxProps={asyncAutocompleteListboxProps(listboxKey)}
            getOptionLabel={(option) => {
              const cpf = formatCpf(option?.cpf);
              return option?.cpf ? `${option.name} — ${cpf}` : option?.name || "";
            }}
            isOptionEqualToValue={(option, value) => Number(option?.id) === Number(value?.id)}
            onInputChange={(event, newInputValue, reason) => {
              if (reason === "input" || reason === "clear") {
                setInputValue(newInputValue);
              }
              handleAsyncAutocompleteInputChange(search, reason, newInputValue);
            }}
            onChange={(event, value) => {
              if (!value?.id) return;
              handleClose();
              openCustomer(value.id);
            }}
            noOptionsText={inputValue.trim().length < 2 ? "Digite ao menos 2 caracteres" : "Nenhum cliente encontrado"}
            renderInput={(params) => (
              <TextField
                {...params}
                autoFocus
                label="Buscar cliente"
                placeholder="Nome ou CPF"
                size="small"
              />
            )}
          />
        </Box>
      </Popover>
    </>
  );
};

export default CustomerSearchButton;
